import momentTz from "moment-timezone";
import moment from "moment";
import { clearAll } from "../services/aha-api";
import Select, {components} from "react-select";
import React from "react";

const { ValueContainer, Placeholder } = components;

// ROUTES
export const SET_PASSWORD = "/set-password";
export const HOME = "/";
export const USERLIST = "/admin/list";
export const FACILITYLIST = "/facility/list";
export const CAREDXDROPSITESLIST = "/caredx-drop-sites/list";
export const HOSPITALLIST = "/hospital/list";
export const LABLIST = "/lab/list";
export const TERRITORYLIST = "/territory/list";
export const ZONELIST = "/zone/list";
export const TROUBLE_LOGIN = "/trouble-login";
export const FORGOT_USER = "/forgot-username";
export const FORGOT_PASSWORD = "/forgot-password";
export const GOOGLE_AUTH = "/google-auth";
export const VERIFY_DEVICE = "/verify-device";
export const ACCESS_STATUS = "/access-status";
export const RESET_PASSWORD = "/reset-password";
export const LINK_EXPIRED = "/link-expired";
export const INVALID_INVITE = "/invalid-id";
export const CONTACT = "/contact";
export const LOST_DEVICE = "/lost-device";
export const DEVICE_LINK_EXPIRED = "/device-link-expired";
export const SCHEDULE = "/schedule";
export const GENERAL = "/general";
export const TRACKER = "/tracker";
export const CHAT = "/chat";
export const STATORDER = "/stat-order";
export const ROUTINEREDRAW = "/routine-redraw";
export const TIMEDDRAW = "/timed-draw";
export const HOMEHEALTH = "/care-at-home";
export const USER_GUIDE = "/user-guide";
export const SEARCH = "/search"
export const CARE_AT_HOME_SCHEDULE = "/care-at-home-schedule";


export const awsPath = "/Prod";
export const rootPath = window.location.href.includes(awsPath)
  ? `${awsPath}/chats`
  : "/chats/";

export const routes = {
  SIGNIN: `${rootPath}`,
  CHAT: `${rootPath}rooms`,
  DEVICE: `${rootPath}devices`,
  MEETING: `${rootPath}meeting`,
  CHAT_ADMIN: `/chats-admin/rooms`
};

//Feature classnames
export const statOrderClass = "page-stat-order";
export const adminClass = "admin-page";
export const trackerClass = "tracker-page";
export const chatClass = "chat-page";
export const adminChatClass = "admin-chat-page";
export const scheduleClass = "schedule-component";
export const careAtHomeScheduleClass = "care-at-home-schedule-component";
export const careAtHomeOrderClass = "page-care-home";

//RegEX
export const REGEX_LOWER_CASE = /[a-z]/;
export const REGEX_UPPER_CASE = /[A-Z]/;
export const REGEX_NUMBER = /[0-9]/;
export const REGEX_SPECIAL_CHARACTER =
  // eslint-disable-next-line no-useless-escape
  /[!-#%-*,-\/:;?@[-\]_{}$+|~=`<>^\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65\u{10100}-\u{10102}\u{1039F}\u{103D0}\u{1056F}\u{10857}\u{1091F}\u{1093F}\u{10A50}-\u{10A58}\u{10A7F}\u{10AF0}-\u{10AF6}\u{10B39}-\u{10B3F}\u{10B99}-\u{10B9C}\u{10F55}-\u{10F59}\u{11047}-\u{1104D}\u{110BB}\u{110BC}\u{110BE}-\u{110C1}\u{11140}-\u{11143}\u{11174}\u{11175}\u{111C5}-\u{111C8}\u{111CD}\u{111DB}\u{111DD}-\u{111DF}\u{11238}-\u{1123D}\u{112A9}\u{1144B}-\u{1144F}\u{1145B}\u{1145D}\u{114C6}\u{115C1}-\u{115D7}\u{11641}-\u{11643}\u{11660}-\u{1166C}\u{1173C}-\u{1173E}\u{1183B}\u{11A3F}-\u{11A46}\u{11A9A}-\u{11A9C}\u{11A9E}-\u{11AA2}\u{11C41}-\u{11C45}\u{11C70}\u{11C71}\u{11EF7}\u{11EF8}\u{12470}-\u{12474}\u{16A6E}\u{16A6F}\u{16AF5}\u{16B37}-\u{16B3B}\u{16B44}\u{16E97}-\u{16E9A}\u{1BC9F}\u{1DA87}-\u{1DA8B}\u{1E95E}\u{1E95F}]/u;
// eslint-disable-next-line no-useless-escape
export const REGEX_USERNAME = /^[a-zA-Z][\.a-zA-Z0-9]{6,20}$/;
export const REGEX_EMAIL_ADDRESS = /\S+@\S+\.\S+/;
export const REGEX_URL = /((http|https)?:\/\/[^\s]+)/g;
export const REGEX_ALPHABETS_ONLY = /[^a-zA-Z]/g;

export const GOOGLE_MAPS_LINK = `https://maps.google.com/`;

//VARIABLES
export const DROPPED_OFF = "Dropped-Off";
export const UNASSIGNED_STATUS = 1;
export const UNACKNOWLEDGED_STATUS = 2;
export const ACKNOWLEDGED_STATUS = 3;
export const CHECK_IN_STATUS = 4;
export const CHECK_OUT_STATUS = 5;
export const REDISPATCH_STATUS = 6;
export const DROPPED_OFF_STATUS = 8;
export const CANCELLED_STATUS = 9;
export const NOTIFIED_CLIENT_STATUS = 10;
export const CANCELLED_NOT_ELIGIBLE_STATUS = 20;
export const NON_DRAW_COMPLETE_STATUS_TEXT = "Non-Draw Complete";
export const NOTIFIED_CLIENT_PARTIAL_STATUS_TEXT = "Notified Client - Partial";
export const NOTIFIED_CLIENT_FINAL_STATUS_TEXT = "Completed";
export const CANCELLED_STATUS_TEXT = "Cancelled";
export const CHECKED_OUT_STATUS_TEXT = "Check-out";
export const GROUP_CHANNEL_TYPE = "$group$";
export const INDIVIDUAL_CHANNEL_TYPE = "$individual$";
export const GROUP_CHANNEL_TYPE_TWO = "$system$";
export const ALL_USERS_GROUP = "$system$All Users";
export const mapFilters = ["facility", "lab", "hospital", "phlebotomist"];
export const tzFilters = [{value: "All", id: 0}, {value: "PT", id: 4}, {value: "MT", id: 3}, {value: "CT", id: 2}, {value: "ET", id: 1}];
export const serviceTypes = {
  1: {
    id: 1,
    name: "Routine Draws",
  },
  4: {
    id: 4,
    name: "Care at Home",
  },
  3: {
    id: 3,
    name: "On Call",
  },
  5: {
    id: 5,
    name: "Drop Off",
  },
};

export const SCHEDULE_SERVICE_TYPE = {
  ROUTINE: {
    ID: 1,
    NAME: "Routine"
  },
  WILL_CALL: {
    ID: 2,
    NAME: "Will Call"
  },
  ON_CALL: {
    ID: 3,
    NAME: "On Call"
  },
  HOME_HEALTH: {
    ID: 4,
    NAME: "Home Health"
  },
  SURGE: {
    ID: 5,
    NAME: "Surge"
  },
  NON_SERVICE_DAY: {
    ID: 6,
    NAME: "Non Service Day"
  },
  NO_COVERAGE: {
    ID: 7,
    NAME: "No Coverage"
  },
  ON_CALL_SURGE: {
    ID: 8,
    NAME: "Surge"
  },
}

export const filterItems = [
  { label: "Territory", value: "territory" },
  { label: "Zone", value: "zone" },
  { label: "Facility", value: "facility" },
  { label: "Phlebotomist", value: "phleb" },
  { label: "Lab", value: "lab" },
  { label: "Hospital", value: "hospital" },
];

export const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const STAT_ALL_STATUSES = [
  { label: "Unassigned", value: "1" },
  { label: "Unacknowledged", value: "2" },
  { label: "Acknowledged", value: "3" },
  { label: "Partial-Completion", value: "PARTIAL_UTO" },
  { label: "Dropped-Off", value: "8" },
  { label: "Redispatch", value: "6" },
  { label: "Check-out", value: "5" },
  { label: "Check-in", value: "4" },
  { label: "Cancelled", value: "9" },
  { label: "Cancelled - Not Eligible", value: "20" },
  { label: "Notified-Client", value: "10" },
];

export const STAT_ALL_OPEN_STATUSES = STAT_ALL_STATUSES.filter(st => st.label !== "Cancelled" && st.label !== "Notified-Client" && st.label !== "Cancelled - Not Eligible");

export const ROUTINE_REDRAW_ALL_OPEN_STATUSES = STAT_ALL_OPEN_STATUSES.filter(st => st.label !== "Dropped-Off");

export const STAT_COMPLETED_ORDERS_STATUSES = STAT_ALL_STATUSES.filter(st => st.label === "Cancelled" || st.label === "Notified-Client" || st.label === "Cancelled - Not Eligible");

export const ROUTINE_REDRAW_COMPLETED_AND_CANCELLED_STATUSES = STAT_ALL_STATUSES.filter(st => st.label === "Cancelled" || st.label === "Dropped-Off" || st.label === "Cancelled - Not Eligible");

export const STAT_COMPLETED_STATUSES = STAT_ALL_STATUSES.filter(st => st.label === "Notified-Client");

export const ROUTINE_REDRAW_COMPLETED_STATUSES = STAT_ALL_STATUSES.filter(st => st.label === "Dropped-Off");

export const STAT_CANCELLED_STATUSES = STAT_ALL_STATUSES.filter(st => st.label === "Cancelled" || st.label === "Cancelled - Not Eligible");

export const STAT_EXCLUDE_CHECK_IN_STATUSES = STAT_ALL_STATUSES.filter(st => st.label === "Unassigned" || st.label === "Unacknowledged" || st.label === "Acknowledged");

export const HOME_HEALTH_ALL_STATUSES = [
  { label: "Acknowledged", value: "3" },
  { label: "Dropped-Off", value: "8" },
  { label: "Check-out", value: "5" },
  { label: "Check-in", value: "4" },
  { label: "Assigned", value: "11" },
  { label: "Unscheduled", value: "12" },
  { label: "Assigned-To-Coordinator", value: "13" },
  { label: "Scheduled", value: "14" },
  { label: "Cancelled", value: "9" },
  { label: "Cancelled - Not Eligible", value: "20" },
  { label: "Unclaimed", value: "15" },
  { label: "Non-Draw Complete", value: "16" },
  { label: "Completed", value: "19" },
];

export const HOME_HEALTH_OPEN_ORDER_STATUSES = HOME_HEALTH_ALL_STATUSES.filter(st => st.label !== "Cancelled" && 
  st.label !== "Unclaimed" && st.label !== "Non-Draw Complete" && st.label !== "Completed" && st.label !== "Cancelled - Not Eligible");

export const HOME_HEALTH_UNSCHEDULED_ORER_STATUSES = HOME_HEALTH_ALL_STATUSES.filter(st => st.label === "Unscheduled" || st.label === "Assigned-To-Coordinator");

export const HOME_HEALTH_COMPLETED_AND_CANCELLED_ORER_STATUSES = HOME_HEALTH_ALL_STATUSES.filter(st => st.label === "Cancelled" || st.label === "Unclaimed"
  || st.label === "Non-Draw Complete" || st.label === "Completed" || st.label === "Cancelled - Not Eligible"
);

export const HOME_HEALTH_EXCLUDE_UNSCHEDULED_ORDER_STATUSES = HOME_HEALTH_ALL_STATUSES.filter(st => st.label !== "Unscheduled" && 
st.label !== "Assigned-To-Coordinator");

export const HOME_HEALTH_COMPLETED_STATUSES = HOME_HEALTH_ALL_STATUSES.filter(st => st.label === "Unclaimed" || st.label === "Non-Draw Complete" || st.label === "Completed");

export const HOME_HEALTH_CANCELLED_STATUSES = HOME_HEALTH_ALL_STATUSES.filter(st => st.label === "Cancelled" || st.label === "Cancelled - Not Eligible");

export const HOME_HEALTH_EXCLUDE_SCHEDULED_STATUSES = HOME_HEALTH_ALL_STATUSES.filter(st => st.label === "Unscheduled" || st.label === "Assigned-To-Coordinator");


export const hasCompanyVehicleOptions = [
  {
    id: 1,
    text: "Yes",
  },
  {
    id: 0,
    text: "No",
  },
];

export const CHAT_TYPES = [
  { label: "Ind/Group Chat", value: 1 },
  { label: "Chat Room", value: 2 }
];

export const startDateForOpenOrders = "04/01/2023";
export const startScheduledDateForOpenOrders = "09/01/2023";
export const SURGE_TYPE = "Surge";
export const NON_SERVICE_TYPE = "Non Service Day";
export const MAXIMUM_ORDER_SIZE_START = 4000; // set -1000 for max order size 5000.
export const MAXIMUM_ORDER_SIZE_END = 6000;

export const TYPE_STAT = "statOrder";
export const TYPE_ROUTINE = "routineRedraw";
export const TYPE_TIMEDDRAW = "timedDraw";
export const TYPE_HOMEHEALTH = "homeHealth";

export const ORDER_TYPE_ROUTINE_REDRAW = "Routine Redraw";
export const ORDER_TYPE_TIMED_DRAW = "Timed draw stat";
export const ORDER_TYPE_STAT = "Stat";
export const ORDER_TYPE_ROUTINE_STAT = "Routine stat";
export const ORDER_TYPE_HOME_HEALTH = "Home Health";

export const DROPOFF_LAB = "AHA Lab";
export const DROPOFF_HOSPITAL = "AHA Reference Hospital";
export const DROPOFF_FEDEX = "Fedex";
export const DROP_OFF_CAREDX_DROP_SITE = "CareDx Drop site";
export const ATTRIBUTE_TYPE_ORDER_REQ = "ORDER REQUISITION";
export const ATTRIBUTE_TYPE_ADDRESS = "Map Search";
export const ATTRIBUTE_TYPE_TEXT = "Text";
export const ATTRIBUTE_TYPE_LIST = "List";
export const ATTRIBUTE_TYPE_IMAGE = "Image";
export const ATTRIBUTE_TYPE_SEARCH = "Search";
export const ATTRIBUTE_LABEL_LAB = "LAB ID";
export const ATTRIBUTE_LABEL_HOSPITAL = "HOSPITAL ID";
export const ATTRIBUTE_GROUP_NAME_AIRPORT_CODE = "Airport_Code";
export const ATTRIBUTE_LABEL_DROP_SITE = "Drop site";
export const ATTRIBUTE_LABEL_ALLOMAP_COURIER = "AlloMap Courier";
export const ATTRIBUTE_REQUISITION_IMAGE = "Requisition_Image_Capture";
export const ATTRIBUTE_FIELD_REQUISITION_IMAGE = "Requisition Image Capture";
export const ATTRIBUTE_GROUP_PATIENT_ID = "PATIENT_ID";
export const ATTRIBUTE_FIELD_PATIENT_ID = "Patient Id";
export const ATTRIBUTE_GROUP_NAME_NPI = "NPI";
export const ATTRIBUTE_GROUP_NAME_ORDERING_PHYSICIAN = 'ORDERING_PHYSICIAN';

export const REQUIRED = "REQUIRED";

export const ADMIN_USER_GUIDE = "ADMIN_USER_GUIDE";

export const NATERA_ID = 1;
export const LEGACY_PARTNER_ID = 2;
export const VILLAGEMD_PARTNER_ID = 5;

export const NATERA_LABEL = "Natera";
export const LEGACY_PARTNER_LABEL = "Legacy";
export const VILLAGEMD_PARTNER_LABEL = "VillageMD";
export const STORY_HEALTH_PARTNER_LABEL = "Story Health";
export const XYZ_PARTNER_LABEL = "XYZ";
export const CAREDX_LABEL = "CareDX";
export const GEVITI_LABEL = "Geviti";

export const VILLGEMD_ATTRIBUTE_GROUP = "ACCOUNT_NUMBER";
export const LEGACY_ATTRIBUTE_GROUP = "AGENCY";

export const CANCEL_TEXT = "CANCELLATION";
export const NATERA_REQUESTED_TEXT = "NATERA_REQUESTED";

export const ACCESSION_TEXT = "ACCESSION";
export const ACCESSION_DATETIME_TEXT = "Accession Date/Time";

// schedule
export const SCHEDULER_BOARD_SECTION_TYPE = 'schedulerBoard';
export const BACKLOG_SECTION_TYPE = 'backlog';

export const ROLE_ADMIN = 'Admin';
export const ROLE_SUPER_ADMIN = 'Super Admin';

export const WILL_CALL_SERVICE_TYPE = "Will Call";
export const INACTIVE_STATUS = "INACTIVE";

export const ROLE_COURIER = "Courier";

export const UNASSIGNED_ORDERS = "Unassigned Orders";

export const USER_TYPES_FOR_PHLEB = [
  {label: "On Call", value: 1},
  {label: "Courier", value: 2},
  {label: "Phleb", value: 3},
]

export const USER_TYPES_FOR_PHLEB_OBJ = {
  "On Call": false,
  "Courier": false,
  "Phleb": false
}


export const DEFAULT_DEVICE_TIMEZONE = {id: null, timezone_name: momentTz.tz.guess(true), name: "Use Device Timezone", abbreviation: momentTz().tz(momentTz.tz.guess(true)).format("z"), isVisible: true};

export const ON_CALL_DELETE_SURGE_WARN = "ON_CALL_DELETE_SURGE_WARN";
export const OTHERS_TEXT = "Others";

// ERROR CODES
export const TIMEZONE_MISMATCH = "TIMEZONE_MISMATCH";
export const MAXIMUM_ORDER_SIZE_WARNING = "MAXIMUM_ORDER_SIZE_WARNING";


export const REFRESH_LISTING_TIMER = 300; // 5mins in seconds;
export const USER_IDLE_TIME = 120; // 2 mins in seconds;


// environment variables
export const API_URL = process.env.REACT_APP_API_URL;
export const BADGE = process.env.REACT_APP_BADGE || "dev";
export const DESKTOP_APP_VERSION = process.env.REACT_APP_DESKTOP_APP_VERSION;
export const SYNCFUSION_KEY = process.env.REACT_APP_SYNCFUSION_KEY;
export const FROM_URL = process.env.REACT_APP_FROM_URL;
export const TO_URL = process.env.REACT_APP_TO_URL;
export const INTERIM_END_DATE = process.env.REACT_APP_INTERIM_END_DATE;
export const MAPBOX_API_KEY = process.env.REACT_APP_MAPBOX_API_KEY;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const DEFAULT_ORDER_SIZE = process.env.REACT_APP_PAGE_SIZE || 3000;
export const ORDER_GRID_NAME = "updatedOrderTable";

export const isOnCallScheduleDateAfterDeployment = (dateStr) => {
  if (INTERIM_END_DATE) {
    const interimDate = moment(INTERIM_END_DATE, "MM/DD/YYYY");
    const inputDate = moment(dateStr, "MM/DD/YYYY");
  
    const currentET = momentTz.tz('America/New_York');
  
    const cutoffTime = momentTz.tz(inputDate.format("MM/DD/YYYY") + ' 06:00:00', 'America/New_York');
  
    // Check if dateStr matches INTERIM_END_DATE
    if (inputDate.isSame(interimDate, 'day')) {
      // If today's date is the same as or after INTERIM_END_DATE
      if (currentET.isSameOrAfter(cutoffTime)) {
        return true;
      }
    } else if (inputDate.isAfter(interimDate, 'day')) {
      return true;
    }
    return false;
  } 
  return true;
};


//COMMON FUNCTIONS
export const logout = () => {
  const myItem = localStorage.getItem("device_info");
  const appVersion = localStorage.getItem(`app_v`);
  const username = localStorage.getItem("username");
  const scheduleFilter = localStorage.getItem(`${username}.scheduleFilter`);
  const homeHealthScheduleFilter = localStorage.getItem(`${username}.homeHealthScheduleFilter`);
  const statOrderFilter = localStorage.getItem(`statOrderFilter`);
  const routineRedrawFilter = localStorage.getItem(`routineRedrawFilter`);
  const timedDrawFilter = localStorage.getItem(`timedDrawFilter`);
  const homeHealthFilter = localStorage.getItem(`homeHealthFilter`);

  const statOrderCustomGrid = localStorage.getItem(`grid${ORDER_GRID_NAME}-${TYPE_STAT}`);
  const routineRedrawCustomGrid = localStorage.getItem(`grid${ORDER_GRID_NAME}-${TYPE_ROUTINE}`);
  const timedDrawCustomGrid = localStorage.getItem(`grid${ORDER_GRID_NAME}-${TYPE_TIMEDDRAW}`);
  const homeHealthCustomGrid = localStorage.getItem(`grid${ORDER_GRID_NAME}-${TYPE_HOMEHEALTH}`);
  const timezone = localStorage.getItem(`tz`);

  const statExport = localStorage.getItem(`export-${ORDER_TYPE_STAT}`);
  const routineExport = localStorage.getItem(`export-${ORDER_TYPE_ROUTINE_REDRAW}`);
  const timedExport = localStorage.getItem(`export-${ORDER_TYPE_TIMED_DRAW}`);
  const hhExport = localStorage.getItem(`export-${ORDER_TYPE_HOME_HEALTH}`);

  localStorage.clear();
  localStorage.setItem("device_info", myItem);
  localStorage.setItem("tz", timezone);
  localStorage.setItem("app_v", appVersion);
  if (statExport) {
    localStorage.setItem(`export-${ORDER_TYPE_STAT}`, statExport);
  }

  if (routineExport) {
    localStorage.setItem(`export-${ORDER_TYPE_ROUTINE_REDRAW}`, routineExport);
  }

  if (timedExport) {
    localStorage.setItem(`export-${ORDER_TYPE_TIMED_DRAW}`, timedExport);
  }

  if (hhExport) {
    localStorage.setItem(`export-${ORDER_TYPE_HOME_HEALTH}`, hhExport);
  }
  scheduleFilter &&
    localStorage.setItem(`${username}.scheduleFilter`, scheduleFilter);
    homeHealthScheduleFilter &&
    localStorage.setItem(`${username}.homeHealthScheduleFilter`, homeHealthScheduleFilter);
  statOrderFilter && localStorage.setItem(`statOrderFilter`, statOrderFilter);
  routineRedrawFilter &&
    localStorage.setItem(`routineRedrawFilter`, routineRedrawFilter);
  timedDrawFilter && localStorage.setItem(`timedDrawFilter`, timedDrawFilter);
  homeHealthFilter && localStorage.setItem(`homeHealthFilter`, homeHealthFilter);
  statOrderCustomGrid && localStorage.setItem(`grid${ORDER_GRID_NAME}-${TYPE_STAT}`, statOrderCustomGrid);
  routineRedrawCustomGrid && localStorage.setItem(`grid${ORDER_GRID_NAME}-${TYPE_ROUTINE}`, routineRedrawCustomGrid);
  timedDrawCustomGrid && localStorage.setItem(`grid${ORDER_GRID_NAME}-${TYPE_TIMEDDRAW}`, timedDrawCustomGrid);
  homeHealthCustomGrid && localStorage.setItem(`grid${ORDER_GRID_NAME}-${TYPE_HOMEHEALTH}`, homeHealthCustomGrid);
  sessionStorage.removeItem("lastTimeStamp");
  window.location.href = "/";
  clearAll();
};

export const setGenerateRandomColor = (str) => {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var colour = "#";
  for (var i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 0xff;
    colour += ("00" + value.toString(16)).substr(-2);
  }
  var aRgbHex = colour.replace("#", "").match(/.{1,2}/g);
  var aRgb = [
    parseInt(aRgbHex[0], 16),
    parseInt(aRgbHex[1], 16),
    parseInt(aRgbHex[2], 16),
  ];
  return aRgb;
};

export const addDays = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const areEqualDates = (dateString = "", dateObj) => {
  let result = false;
  if (!dateString || !dateObj) {
    return false;
  }

  const dateArr = dateString ? dateString.split("-") : [];

  if (dateArr.length > 2) {
    const selectedDate = new Date(dateObj);
    const date1 = selectedDate.getDate();
    const month1 = selectedDate.getMonth() + 1;
    const year1 = selectedDate.getFullYear();

    const date2 = dateArr[2];
    const month2 = dateArr[1];
    const year2 = dateArr[0];

    if (date1 == date2 && month1 == month2 && year1 == year2) {
      result = true;
    }
  }
  return result;
};

export const areEqualDatesTwo = (dateObj1, dateObj2) => {
  let result = false;
  if (!dateObj1 && !dateObj2) {
    return true;
  } else if (!dateObj1 || !dateObj2) {
    return false
  }

  const selectedDate = new Date(dateObj1);
  const date1 = selectedDate.getDate();
  const month1 = selectedDate.getMonth() + 1;
  const year1 = selectedDate.getFullYear();

  const selectedDateTwo = new Date(dateObj2);
  const date2 = selectedDateTwo.getDate();
  const month2 = selectedDateTwo.getMonth() + 1;
  const year2 = selectedDateTwo.getFullYear();

  if (date1 == date2 && month1 == month2 && year1 == year2) {
    result = true;
  }
  return result;
};

export const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
);

export const filterPassedTime = (time) => {
  const currentDate = new Date();
  const selectedDate = new Date(time);

  return currentDate.getTime() < selectedDate.getTime();
};

function compareDateTime(datetimeString1, datetimeString2) {
  // Extract date and time parts from datetime strings
  const [date1, time1] = datetimeString1.split(' ');
  const [date2, time2] = datetimeString2.split(' ');

  // Parse date parts
  const [year1, month1, day1] = date1.split('-').map(Number);
  const [year2, month2, day2] = date2.split('-').map(Number);

  // Parse time parts
  const [hour1, minute1, second1] = time1.split(':').map(Number);
  const [hour2, minute2, second2] = time2.split(':').map(Number);

  // Create Date objects
  const dateTime1 = new Date(year1, month1 - 1, day1, hour1, minute1, second1);
  const dateTime2 = new Date(year2, month2 - 1, day2, hour2, minute2, second2);

  // Compare the Date objects
  if (dateTime1 < dateTime2) {
      return true;
  } else {
      return false;
  }
}

export const filterPassedTimeForCheckinCheckoutDropOff = (time, newTz) => {
  const currentDateTime = momentTz().tz(newTz);
  const selectedDateTime = momentTz(time);
  return compareDateTime(selectedDateTime.format('YYYY-MM-DD HH:mm:ss'), currentDateTime.format('YYYY-MM-DD HH:mm:ss'));
};

export const dropOffTypes = [
  { label: "Lab", value: "lab" },
  { label: "Hospital", value: "hospital" },
  { label: "Courier", value: "courier" },
];

export const getDataByProperty = (data = [], value, property) => {
  let res = "";
  data.forEach((d) => {
    if (d[property] == value) {
      res = d;
    }
  });
  return res;
};

export const getLabelByValue = (data = [], value) => {
  let res = "";
  data.forEach((d) => {
    if (d.value == value) {
      res = d.label;
    }
  });
  return res;
};

export const getLabelValueObjectByValue = (data = [], value) => {
  let res = "";
  data.forEach((d) => {
    if (d.value == value) {
      res = d;
    }
  });
  return res;
};

export const getLocalDateTime = (isOnlyDate = false) => {
  // current localDateTime
  var now = new Date();
  var utcString = now.toISOString().substring(0, 19);
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var day = now.getDate();
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  var localDatetime =
    year +
    "-" +
    (month < 10 ? "0" + month.toString() : month) +
    "-" +
    (day < 10 ? "0" + day.toString() : day) +
    "T" +
    (hour < 10 ? "0" + hour.toString() : hour) +
    ":" +
    (minute < 10 ? "0" + minute.toString() : minute) +
    utcString.substring(16, 19);

  let localDateTimeTwo =
    year +
    "-" +
    (month < 10 ? "0" + month.toString() : month) +
    "-" +
    (day < 10 ? "0" + day.toString() : day);

  return isOnlyDate ? localDateTimeTwo : localDatetime;
};

export function findLastIndex(items, callback) {
  return items.reduce((acc, curr, index) => (callback(curr) ? index : acc), -1);
}

export const calculateMaxTime = (checkoutDate, checkinDate, date) => {
  if (!checkoutDate) {
    let isToday = moment(checkinDate || date).isSame(moment(), "day");
    if (isToday) {
      return moment(date).toDate();
    }
    return moment(checkinDate).endOf("day").toDate();
  } else {
    let isToday = moment(checkoutDate).isSame(checkinDate || date, "day");
    if (isToday) {
      return moment(checkoutDate).toDate();
    }
    return moment(checkoutDate).endOf("day").toDate();
  }
};

export const calculateMaxTimeCheckOut = (checkoutDate, date) => {
  let isToday = moment(checkoutDate).isSame(date, "day");
  if (isToday) {
    return moment(date).toDate();
  }
  return moment(checkoutDate).endOf("day").toDate();
};

export const compareTestListItems = (testList = [], originalTestList = []) => {

  const isAnyItemDeleted = testList.some(item => item.deleted);

  let tempListItems = [...testList]

  if (isAnyItemDeleted) {
    tempListItems = tempListItems.filter(item => !item.deleted);
  }
  const labels1 = tempListItems.map(item => `${item.testCode?.label || ''} ${item.id || ''} ${item.orderCollectionMethod || ''}`).sort();
  const labels2 = originalTestList.map(item => `${item.testCode?.label || ''} ${item.id || ''} ${item.orderCollectionMethod || ''}`).sort();

  const areBothListSame = JSON.stringify(labels1) === JSON.stringify(labels2);
  if (areBothListSame) {
    return true;
  } else {
    return !hasDuplicateLabels(tempListItems);
  }
};

export const compareTestListItemsToDisableCheckin = (testList = [], originalTestList = []) => {

  const isAnyItemDeleted = testList.some(item => item.deleted);

  let tempListItems = [...testList]

  if (isAnyItemDeleted) {
    tempListItems = tempListItems.filter(item => !item.deleted);
  }
  const labels1 = tempListItems.map(item => `${item.testCode?.label || ''} ${item.id || ''} ${item.deleted || ''}`).sort();
  const labels2 = originalTestList.map(item => `${item.testCode?.label || ''} ${item.id || ''} ${item.deleted || ''}`).sort();

  const areBothListSame = JSON.stringify(labels1) === JSON.stringify(labels2);
  if (areBothListSame) {
    return true;
  } else {
    return false;
  }
};

const hasDuplicateLabels = (arr) => {
  const labelSet = new Set();

  for (const item of arr) {
    const label = item.testCode?.label;
    if (label && labelSet.has(label)) {
      return true; // Duplicate label found
    }
    labelSet.add(label);
  }

  return false; // No duplicate label found
}

export const customToFixed = (value) => {
  let res = value;
  let valStr = value ? value.toString() : "";
  let valPrecision = valStr.length - (valStr.indexOf(".") + 1);

  if (valPrecision >= 6) {
    res = res.toFixed(6);
  }
  // return res;
  return value;
}
export function replaceNullWithEmptyStringAndReturnUpdated(obj) {
  const updatedObj = { ...obj };

  for (const key in updatedObj) {
    if (updatedObj.hasOwnProperty(key) && updatedObj[key] === null) {
      updatedObj[key] = {};
    }
  }

  return updatedObj;
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function isValidNumber(str) {
  const numberRegex = /^-?\d+(\.\d+)?$/;
  return numberRegex.test(str);
}

export function showNoCoverageInfoIcon(onCallUsers = [], zoneId) {
  let noCoverageUser = onCallUsers.filter(user => user.user_id == null);
  let otherThanNoCoverageUser = onCallUsers.filter(user => user.user_id != null);

  const hasZoneInNoCoverage = noCoverageUser.some(user => user.services && user.services.some(service => service.territories && Object.keys(service.territories).length > 0
    && Object.keys(service.territories).some(terrId => service.territories[terrId].events && Object.keys(service.territories[terrId].events).length > 0 && Object.keys(service.territories[terrId].events).some(eventId => service.territories[terrId].events[eventId].zones && service.territories[terrId].events[eventId].zones.length > 0 && service.territories[terrId].events[eventId].zones.some(zone => zone.zone_id == zoneId)))));

  const hasNoZoneInExceptNoCoverage = otherThanNoCoverageUser.every(user => !user.services || user.services.every(service => !service.territories || Object.keys(service.territories).length == 0
    || Object.keys(service.territories).every(terrId => !service.territories[terrId].events || Object.keys(service.territories[terrId].events).length == 0 || Object.keys(service.territories[terrId].events).every(eventId => !service.territories[terrId].events[eventId].zones || service.territories[terrId].events[eventId].zones.length == 0 || service.territories[terrId].events[eventId].zones.every(zone => zone.zone_id != zoneId)))));
  return hasZoneInNoCoverage && hasNoZoneInExceptNoCoverage;
}

export const isStatusDisabled = (status, data = [], type = "positive") => {
  if (type === "negative") {
    return !data.some(st => st.label === status);
  }
  return data.some(st => st.label === status);
}
export const getURLbyEntity = (entity, id) => {
  let url = "";
    switch (entity) {
      case "Stat":
        url = `${STATORDER}?id=${id}`;
        break;
      case "Timed draw stat":
        url = `${TIMEDDRAW}?id=${id}`;
        break;
      case "Home Health":
        url = `${HOMEHEALTH}?id=${id}`;
        break;
      case "Facility":
        url = `${FACILITYLIST}?id=${id}`;
        break;
      case "CareDX Drop site":
        url = `${CAREDXDROPSITESLIST}?id=${id}`;
        break;
      case "Hospital":
        url = `${HOSPITALLIST}?id=${id}`;
        break;
      case "Lab":
        url = `${LABLIST}?id=${id}`;
        break;
      case "Person":
        url = `${USERLIST}?id=${id}`;
        break;
      case "Routine Redraw":
        url = `${ROUTINEREDRAW}?id=${id}`;
        break;
      case "Redraw stat":
        url = `${STATORDER}?id=${id}`;
        break;
      default:
        url = "";
        break;
    }
  return url;
}

export const getTimeByFormat = (timeString = "", format = "12") => {
  if (format === "12") {
    const time24Moment = moment(timeString, 'HH:mm');

    // Format the time in 12-hour format with AM/PM
    const time12 = time24Moment.format('h:mm a');
  
    return time12;
  }
  return timeString;
}

export const convertToMMDDYYYY = (datetime, timezone, type, isTimeOnly = false, noCoversion = false) => {
  let result = ` ${noCoversion ? datetime : moment(datetime).format(isTimeOnly ? "HH:mm:ss" : "MM/DD/YYYY HH:mm:ss")} ${timezone && timezone.abbreviation ? `${timezone.abbreviation} ${type} TZ` : ""}`
  return result;
}

export function compareTimes(date, timeString1, hasDate1, timeString2, hasDate2,  tz1 = {}, tz2 = {}, type = "start") {
  if (!timeString1 || !timeString2 || !tz1 || !tz1.timezone_code || !tz2 || !tz2.timezone_code) {
    return false;
  }

  const parseTime = (timeString, timezone, hasDate) => {
      const time = timeString;
      const mappedTz = timezone || momentTz.tz.guess(true);
      return momentTz.tz(`${!hasDate ? `${momentTz(date).format('YYYY-MM-DD')} ` : ""}${time}`, "YYYY-MM-DD hh:mm A", mappedTz);
  };

  const time1 = parseTime(timeString1, tz1.timezone_code || "", hasDate1);
  const time2 = parseTime(timeString2, tz2.timezone_code || "", hasDate2);
  let result = false;
  if (type === "start") {
    // if checkin greater than chekout OR spin grater than checkout
    if (time1.isAfter(time2)) {
      console.log(`${timeString1} is greater than ${timeString2}`);
      result = true;
    }
  } else {
    // if checkout is lesser than checkin or spin lesser than checkout
    if (time1.isBefore(time2)) {
      console.log(`${timeString1} is lesser than ${timeString2}`);
      result = true;
    }
  }
  return result;
}

export const CustomValueContainer = ({ children, ...props }) => {
	const showPlaceholder = props.selectProps && (!props.selectProps.inputValue && (!props.selectProps.value || !props.selectProps.value.value));

	return (
		<ValueContainer {...props}>
			{showPlaceholder && <Placeholder {...props} isFocused={props.isFocused}>
				{props.selectProps.placeholder}
			</Placeholder>}
			{React.Children.map(children, child =>
				child && child.type !== Placeholder ? child : null
			)}
		</ValueContainer>
	);
};

export const checkAppVersion = () => {
  const appVersion = localStorage.getItem("app_v");

  if (!appVersion || appVersion !== DESKTOP_APP_VERSION) {
    localStorage.setItem('app_v', DESKTOP_APP_VERSION);
    window.location.reload();
  }
}

export const getMimeType = (filePath) => {
  const ext = filePath.split(".").pop().toLowerCase();
  const mimeTypes = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    txt: "text/plain",
    csv: "text/csv",
    zip: "application/zip",
    json: "application/json",
  };
  return mimeTypes[ext] || "application/octet-stream";
};
